export {
  RestrictionType,
  useRequireTradingAllowed,
  useTradingAllowed,
} from "@/contexts/trading-allowed";

/** @deprecated Use `useTradingAllowed()` instead */
export { useTradingAllowed as useIsTradingAllowed } from "@/contexts/trading-allowed";
